// extracted by mini-css-extract-plugin
export default {"applicationForm":"applicationForm_applicationForm__sZEHS"};